import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewTablePage } from 'src/app/shared/modules/data-view-table/view-table.service';
import { DataViewTableConfig, ViewTableComponent } from 'src/app/shared/modules/data-view-table/view-table/view-table.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StylistsService } from '../../stylists.service';
import {
  ADMIN_LEVEL_FILTERS,
  ALL_USERS_QUEUES_FILTERS,
  getDataTableColumnConfig,
  getContextMenuConfig,
  CHECKBOX_FILTERS
} from '../config.const';
import { Router } from '@angular/router';
import { BaseUserQueue } from '../base-user-queue';
import { AuthService } from 'src/app/shared/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '@hss-m/uikit-common';

@Component({
  selector: 'app-all-users-queues',
  templateUrl: './all-users-queues.component.html',
  styleUrls: ['./all-users-queues.component.scss']
})
export class AllUsersQueuesComponent extends BaseUserQueue implements OnInit {

  @ViewChild(ViewTableComponent) viewTableComponent: ViewTableComponent;
  config: DataViewTableConfig = {
    url: 'stylist/users/all-queues',
    dataKey: 'queues',
    selection: true,
    page: new ViewTablePage(),
    columns: getDataTableColumnConfig(this).filter(col => !['last_stock_check'].includes(col.name)),
    noContentMessage: 'No Queues found',
    contextMenuConfig: getContextMenuConfig(this),
    filtersValueRetain: true
  };
  filterId = 'all-user-queues';
  showBreadcrumb = true;
  breadcrumbItems = [{'label': 'Queues'}, {'label': 'All Queues'}];

  constructor(
    protected override deviceService: DeviceDetectorService,
    protected override readonly stylistsService: StylistsService,
    protected override router: Router,
    protected override authService: AuthService,
    protected override toastService: ToastService,
    protected override modalService: NgbModal
  ) {
    super(stylistsService, router, deviceService, authService, toastService, modalService);
    this.config.page.pageNumber = 0;
    this.filters = ALL_USERS_QUEUES_FILTERS(this);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override postFirebaseAuth() {
    if(this.isAdmin) {
      const adminFilters = JSON.parse(JSON.stringify(ADMIN_LEVEL_FILTERS));
      const extraFilters = JSON.parse(JSON.stringify(CHECKBOX_FILTERS));
      this.filters.push(...adminFilters, ...extraFilters);
    }
    super.onInit();
  }

  getViewTableComponent(): ViewTableComponent {
    return this.viewTableComponent;
  }

  getNameOfSelectedUser(){
    return '';
  }

  usersKey(row: any) {
    const item = `${row.uid} - ${row.first_name} ${row.last_name || ''}`;
    return item;
  }
}
